import { Box, Grid2, Stack, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import SingleVideo from "../HomePage/SingleVideo";
import SingleCreator from "../Creators/SingleCreator";
import { South } from "@mui/icons-material";
import { ErrorSnackbar } from "../Common/CustomSnackbar";

const CommunityContent = ({
  title,
  type,
  allData,
  setDrawerState,
  setCreatorData,
  setPaidVideoData,
  setup,
  pageNo,
  loadMoreDisabled,
  dontShowActions,
  refreshFunction,
  queryParam,
  loadMore,
}) => {
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
  const videoRefs = useRef([]);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handlePlayPause = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });

    if (currentPlayingIndex === index) {
      videoRefs.current[index].pause();
      setCurrentPlayingIndex(null);
    } else {
      videoRefs.current[index].play();
      setCurrentPlayingIndex(index);
    }
  };

  return (
    <Box sx={{ pb: 12 }}>
      {/* {allData?.length === 0 && (
        <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Box
            sx={{
              width: "100%",
              height: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <img
              src={require("../../assets/icons/no-results.png")}
              style={{
                height: "50px",
                width: "50px",
              }}
              alt="no-content"
            />
            <Typography
              sx={{
                fontFamily: "Inter-SemiBold",
                fontSize: "24px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {title === "Paid Videos"
                ? "You have not subscribed to any content yet!"
                : title === "My Videos"
                ? "You have not uploaded any content yet!"
                : "You have not subscribed to any creator yet!"}
            </Typography>
          </Box>
        </Grid2>
      )} */}

      {type === "videos" && (
        <Grid2 container spacing={2} sx={{ pt: 2 }}>
          {allData &&
            allData?.map((item, index) => (
              <Grid2
                item
                key={index}
                size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                sx={{ position: "relative" }}
              >
                <SingleVideo
                  item={item}
                  index={index}
                  videoRef={(ref) => (videoRefs.current[index] = ref)}
                  onPlayPause={() => handlePlayPause(index)}
                  isPlaying={currentPlayingIndex === index}
                  smallPlayBtn
                  dontShowActions={dontShowActions}
                  borderRadius
                  noCreator
                  paid
                />
              </Grid2>
            ))}
        </Grid2>
      )}

      {type === "creators" && (
        <Grid2 container spacing={2} sx={{ pt: 2 }} className="step-3">
          {allData?.map((item, index) => (
            <Grid2
              item
              key={index}
              size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
              sx={{
                position: "relative",
                overflow: "hidden",
                "&:hover .overlay": {
                  opacity: 1,
                },
              }}
            >
              <SingleCreator
                item={item}
                setup={setup}
                setDrawerState={setDrawerState}
                setCreatorData={setCreatorData}
              />
            </Grid2>
          ))}
        </Grid2>
      )}

      {type === "all" && (
        <Grid2 container spacing={2} sx={{ pt: 2 }}>
          {allData &&
            allData?.map((item, index) => (
              <Grid2
                item
                key={index}
                size={{ xs: 4 }}
                sx={{ position: "relative" }}
              >
                {item?.type === "post" ? (
                  <SingleVideo
                    item={item}
                    index={index}
                    videoRef={(ref) => (videoRefs.current[index] = ref)}
                    onPlayPause={() => handlePlayPause(index)}
                    isPlaying={currentPlayingIndex === index}
                    smallPlayBtn
                    borderRadius
                    noCreator
                    dontShowActions={dontShowActions}
                    paid
                    smallH
                  />
                ) : (
                  <SingleCreator item={item} setDrawerState={setDrawerState} />
                )}
              </Grid2>
            ))}
        </Grid2>
      )}

      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />

      <Box
        onClick={
          loadMoreDisabled
            ? () => {
                setErrorState({
                  error: true,
                  message: "No more content to load.",
                });
              }
            : loadMore
        }
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          my: 2,
          backgroundColor: loadMoreDisabled ? "#333" : "#000",
          borderRadius: "0px",
          cursor: "pointer",
          py: 1.5,
          gap: 2,
          transition: "background-color 0.3s, transform 0.2s", // Add hover effects
          "&:hover": {
            backgroundColor: "#333", // Slightly lighter background on hover
            transform: "scale(0.98)", // Subtle zoom effect
          },
          "&:active": {
            transform: "scale(0.98)", // Press effect
          },
        }}
      >
        <Typography
          sx={{ color: "#fff", fontFamily: "Inter-Regular", fontWeight: 500 }}
        >
          Load More
        </Typography>
        <South sx={{ fontSize: "18px", color: "#fff" }} />
      </Box>
    </Box>
  );
};

export default CommunityContent;
